import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import DPR from "@/pages/DPR";
import Stock from "@/pages/Stock";
import Power from "@/pages/Power";
import InwardOutward from "@/pages/InwardOutward";
import Models from "@/pages/Models";
import Users from "@/pages/Users";
import Processes from "@/pages/Processes";
import BOMMatrix from "@/pages/BOMMatrix";
import Buffing from "@/pages/Buffing";
import Approvals from "@/pages/Approvals";
import ActivityLog from "@/pages/ActivityLog";
import ScrapReport from "@/pages/ScrapReport";
import Inventory from "@/pages/Inventory";
import Audit from "@/pages/Audit";
import ModelBOM from "@/pages/ModelBOM";
import Electrolysis from "@/pages/Electrolysis";
import CostSheet from "@/pages/CostSheet";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute module="dashboard"><Dashboard /></ProtectedRoute>} />
            <Route path="/dpr" element={<ProtectedRoute module="dpr"><DPR /></ProtectedRoute>} />
            <Route path="/stock" element={<ProtectedRoute module="stock"><Stock /></ProtectedRoute>} />
            <Route path="/power" element={<ProtectedRoute module="power"><Power /></ProtectedRoute>} />
            <Route path="/inward-outward" element={<ProtectedRoute module="gatepass"><InwardOutward /></ProtectedRoute>} />
            <Route path="/electrolysis" element={<ProtectedRoute module="electrolysis"><Electrolysis /></ProtectedRoute>} />
            <Route path="/cost-sheet" element={<ProtectedRoute module="cost-sheet"><CostSheet /></ProtectedRoute>} />
            <Route path="/buffing" element={<ProtectedRoute module="buffing"><Buffing /></ProtectedRoute>} />
            <Route path="/approvals" element={<ProtectedRoute module="approvals"><Approvals /></ProtectedRoute>} />
            <Route path="/models" element={<ProtectedRoute module="processes"><Models /></ProtectedRoute>} />
            <Route path="/processes" element={<ProtectedRoute module="processes"><Processes /></ProtectedRoute>} />
            <Route path="/bom" element={<ProtectedRoute module="bom"><BOMMatrix /></ProtectedRoute>} />
            <Route path="/model-bom" element={<ProtectedRoute module="inventory"><ModelBOM /></ProtectedRoute>} />
            <Route path="/inventory" element={<ProtectedRoute module="inventory"><Inventory /></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute superAdminOnly><Users /></ProtectedRoute>} />
            <Route path="/log" element={<ProtectedRoute adminOnly><ActivityLog /></ProtectedRoute>} />
            <Route path="/scrap" element={<ProtectedRoute module="scrap"><ScrapReport /></ProtectedRoute>} />
            <Route path="/audit" element={<ProtectedRoute module="audit"><Audit /></ProtectedRoute>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;

